import { BusModuleRoute } from 'frontend/bus-module-routes'
import { BusModuleSubsystem } from 'frontend/bus-module-subsystems'
import { IDataModelTypeConfig } from 'frontend/dataModels/types/IDataModelTypeConfig'
import { Location } from 'frontend/locations'
import { markRaw } from 'vue'

export const BusModuleRouteDataModelTypeConfig: IDataModelTypeConfig = {
  fields: [
    'id',
    'eid',
    'name',
    'updated_at',
    'created_at',
    'origin_route_id',
    'recalculate_status',
    'recalculate_errors',
    { virtual_origin_route: ['id', 'name'] },
    { virtual_returning_route: ['id', 'name'] },
    { start_location: ['id', 'name', 'time_zone'] },
    { end_location: ['id', 'name', 'time_zone'] },
    { bus_module_subsystem: ['id', 'name'] },
    {
      bus_route_stops: [
        'id',
        'name',
        'position',
        { location: ['id', 'name', 'latitude', 'longitude'] },
        { arrival_bay_transportation_point: ['id', 'name', 'longitude', 'latitude'] },
        {
          departure_bay_transportation_point: ['id', 'name', 'longitude', 'latitude'],
        },
        'minutes_minimal_idle_time',
        'calculated_bay_to_bay_time',
        'calculated_transit_time',
        'overridden_bay_to_bay_time',
        'overridden_transit_time',
      ],
    },
    'overridden_end_transit_time',
    'calculated_end_transit_time',
  ],
  subscriptions: {
    items: 'BusRoutesChannel',
    busModuleSubsystems: 'BusModuleSubsystemsFlatChannel',
    locations: 'LocationsWithPositionChannel',
  },
  defaultColumns: [
    'eid',
    'name',
    'startLocation',
    'endLocation',
    'busRouteStops',
    'busModuleSubsystem',
    'originRouteId',
  ],
  columnConfig: {
    eid: {
      label: 'EID',
      header: {
        sort: 'eid',
      },
      cell: {
        kind: 'simple',
        path: 'eid',
      },
    },
    name: {
      label: 'Name',
      header: {
        sort: 'name',
      },
      cell: {
        kind: 'simple',
        path: 'name',
      },
    },
    startLocation: {
      label: 'Start depot',
      header: {
        sort: 'startLocationName',
      },
      cell: {
        kind: 'component',
        component: markRaw(Location),
        componentProps: data => ({ location: data.startLocation }),
      },
    },
    endLocation: {
      label: 'End depot',
      header: {
        sort: 'endLocationName',
      },
      cell: {
        kind: 'component',
        component: markRaw(Location),
        componentProps: data => ({ location: data.endLocation }),
      },
    },
    busRouteStops: {
      label: 'Bus stops',
      cell: {
        kind: 'component',
        component: 'limited-components-list',
        componentProps: el => ({
          items: el.busRouteStops.sort((a, b) => a.position - b.position),
          limit: 5,
          component: markRaw(Location),
          componentProps: busRouteStop => ({ location: busRouteStop.location }),
        }),
      },
    },
    busModuleSubsystem: {
      label: 'Subsystem',
      cell: {
        kind: 'component',
        component: markRaw(BusModuleSubsystem),
        componentProps: data => ({ busModuleSubsystem: data.busModuleSubsystem }),
      },
    },
    originRoute: {
      label: 'Origin route',
      cell: {
        kind: 'component',
        component: markRaw(BusModuleRoute),
        componentProps: data => ({ busModuleRoute: data.virtualOriginRoute }),
      },
    },
    returningRoute: {
      label: 'Returning route',
      cell: {
        kind: 'component',
        component: markRaw(BusModuleRoute),
        componentProps: data => ({ busModuleRoute: data.virtualReturningRoute }),
      },
    },
    createdDatetime: {
      label: 'Created datetime',
      header: {
        sort: 'createdAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: item => ({ t: item.createdAt }),
      },
    },
    createdTime: {
      label: 'Created time',
      header: {
        sort: 'createdAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: item => ({
          t: item.createdAt,
          format: 'timeOnly',
        }),
      },
    },
    createdDate: {
      label: 'Created date',
      header: {
        sort: 'createdAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: item => ({
          t: item.createdAt,
          format: 'dateOnly',
        }),
      },
    },
    updatedDatetime: {
      label: 'Updated datetime',
      header: {
        sort: 'updatedAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: item => ({ t: item.updatedAt }),
      },
    },
    updatedTime: {
      label: 'Updated time',
      header: {
        sort: 'updatedAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: item => ({
          t: item.updatedAt,
          format: 'timeOnly',
        }),
      },
    },
    updatedDate: {
      label: 'Updated date',
      header: {
        sort: 'updatedAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: item => ({
          t: item.updatedAt,
          format: 'dateOnly',
        }),
      },
    },
    recalculateStatus: {
      label: 'Recalculate status',
      header: {
        sort: 'recalculateStatus',
      },
      cell: {
        kind: 'simple',
        path: 'recalculateStatus',
      },
    },
  },
}
